export enum ToolType {
  brush,
  magic,
  lasso,
  cleanup,
  remove,
  finetune,
  usePrompt,
  replaceBackground,
  removeBackground,
  glamRoom,
  none,
  animateDesign,
  variateDesign,
  poseEdit,
  makeSeamless,
  faceFix,
  productFix,
  retouchDefects,
  fixGarmentTexture,
  expandImage,
  // REF-6367 — Studio Polish. Needs its own ToolType even though it takes no selection: the edit
  // panel's footer renders its Apply button by switching on `selectedTool`, so a menu item with no
  // `defaultTool` opens its panel with NO way to submit.
  polish,
}

export enum Dimensions {
  auto = "auto",
  horizontal = "768_512",
  sqaure = "512_512",
  portrait = "512_768",
}

export const DESIGN_TYPES_ARRAY = [
  "design",
  "pattern",
  "edit",
  "refine_face",
  "refine_hand",
  "change_material",
  "change_print_2",
  "change_fabric",
  "change_color",
  "tailoring",
  "design_video",
  "seamless_tile",
  "extract_print",
] as const;

export const DEFAULT_BRUSH_WIDTH = 72;
export const MINUMUM_BRUSH_WIDTH = 1;
export const MAX_BRUSH_WIDTH = 150;
